"use client";
import { Dialog, DialogHeader, DialogBody } from "@dxp-feed/ui/Dialog";
import { Text } from "@dxp-feed/ui/Text";
import { Box } from "@dxp-feed/ui/Box";
import ImageWrapper from "@/components/ImageWrapper";
import Link from "@/components/Link";
import {
  useAppDispatch,
  useAppSelector,
} from "@/utils/hooks/reactUseCustomHooks";
import { sceneStatesTrigger } from "@/utils/redux/gigya/scene";
import { handlePopupClose } from "@/helpers/sceneCardFunctions";
import { Button } from "@dxp-feed/ui";

const CreateScenePopup = () => {
  const { popupType } = useAppSelector((state) => state.sceneSlice);
  const dispatch = useAppDispatch();

  const addCard = () => {
    dispatch(
      sceneStatesTrigger({
        popupType: "addCard",
        suppression: false,
      })
    );
  };

  const closeDialog = () => {
    dispatch(
      sceneStatesTrigger({
        popupType: "",
        suppression: false,
      })
    );
  };

  return (
    <Dialog
      isOpen={popupType == "createScenePopup"}
      onClose={closeDialog}
      className="xs:max-w-[464px] max-w-full xs:w-full w-[90%] outline-none mx-6"
      closeOnOverlayClick={false}
    >
      <DialogHeader className="justify-end">
        <Button
          className="text-brandBlack text-2xl hover:text-gray-800  !bg-brandWhite !before:hidden !border-0 !hover:border-0 !focus:border-0 !hover:bg-brandWhite !focus:bg-brandWhite focus:text-brandBlack"
          onClick={() => {
            handlePopupClose({
              cookie: "create_scene_suppress",
              suppressType: "hard",
            });
            closeDialog();
          }}
          aria-label="Close Button"
        >
          <Text as="span" className="icon-close flex w-4 text-base" />
        </Button>
      </DialogHeader>
      <DialogBody className="pb-0">
        <Box className="w-full flex justify-center pb-6">
          <ImageWrapper
            src="/scene-card-vertical.jpg"
            className="object-cover "
            alt="scene card vertical"
            width={134}
            height={160}
            style={{ objectFit: "cover" }}
          />
        </Box>
        <h2 className="xs:text-xl text-base font-sans text-center font-bold">
          Create a Scene+ account and enjoy personalized offers.
        </h2>
        <Box className="flex gap-4 py-6 flex-col-reverse sm:flex-row">
          <Button
            className="buttonSelectStore text-[14px]  !px-4 !border-[1px] !border-grey350 sm:!w-1/2 !w-full focus:!text-brandWhite"
            type="submit"
            onClick={() => {
              handlePopupClose({
                cookie: "create_scene_suppress",
                suppressType: "soft",
              });
              closeDialog();
            }}
            aria-label={"Not Right Now"}
          >
            Not Right Now
          </Button>
          <Button
            className="buttonDirection !text-[14px] !px-4 flex gap-3 justify-center items-center sm:!w-1/2 !w-full sm:mt-0 mt-4 !border-[1px]  !border-[#003D2A] focus:!text-[#003D2A]"
            type="submit"
            asChild
          >
            <Link
              href={process.env.NEXT_PUBLIC_REGISTER_SCENE_CARD_LINK || ""}
              className="w-full sm:!w-1/2 text-[14px]"
              onClick={() => {
                // addDataLayer({
                //   event: "scene_registration",
                //   click_text: "Register Scene+ Card",
                //   click_url: "step_1",
                //   page_title:
                //     typeof window != "undefined" ? document?.title : "",
                // });
              }}
              target="_blank"
            >
              Create Account
            </Link>
          </Button>
        </Box>
        <Text as="p" className="text-body text-center">
          Already have a Scene+ card{" "}
          <Link
            onClick={() => {
              addCard();
            }}
            href={"#"}
            className="text-body sm:!w-1/2 !w-full font-semibold text-[#003D2A] pb-6 underline"
          >
            Link Scene+ Card
          </Link>
        </Text>
      </DialogBody>
    </Dialog>
  );
};

export default CreateScenePopup;
